import React, { useState, useEffect } from "react";
import Styles from "../ResourcesPlanner.module.scss";
import { CircleX, TriangleAlert, X } from "lucide-react";
import { Cross } from "../../../modules/default-svg";
import { ConflictsToastType } from "../utils/utils";
import SafeHtml from "../../../components/safeHtml/SafeHtml";

const ConflictsToast = (props) => {
  const { data, timeout = null, onClose, index = 0 } = props;
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (data === null) {
      setShow(false);
      return;
    }
    if (data) {
      setShow(true);
      if (timeout) {
        const intervalId = setTimeout(() => {
          setShow(false);
        }, timeout);
        return () => clearTimeout(intervalId);
      }
    }
  }, [data]);

  const removeToast = () => {
    setShow(false);
    if (onClose) {
      onClose();
    }
  }
  return show ? (
    <div 
      className={`${Styles.conflictsToastContainer} ${Styles.topRight}`}
      style={{ top: `${23 + index * 90}px` }}>
      <div className="z-3">
        <div className="d-flex justify-content-between align-items-center">
          <div className="d-flex justify-content-between align-items-center">
            <p className={`${Styles.conflictsToastTitle}`}>
              <div className="d-flex align-items-center gap-2">
                {data?.type === ConflictsToastType.ERROR ? <CircleX size={18} color="#FF4D4F" /> : <TriangleAlert size={18} color="#f97316" />}
                <span>{data?.title || (data?.type === ConflictsToastType.ERROR ? "Error" : "Warning!")}</span>
                <span onClick={removeToast} className={`${Styles.closeBtn}`}>
                  <Cross />
                </span>
              </div>
              {data?.body && (
                <span className={`${Styles.conflictsToastBody}`}>
                  <SafeHtml html={data.body} />
                </span>
              )}
            </p>
          </div>
        </div>
      </div>
    </div>
  ) : (
    <></>
  );
};

export default ConflictsToast;
